import { render, staticRenderFns } from "./ClipsPanel.vue?vue&type=template&id=44681458"
import script from "./ClipsPanel.vue?vue&type=script&lang=js"
export * from "./ClipsPanel.vue?vue&type=script&lang=js"
import style0 from "./ClipsPanel.vue?vue&type=style&index=0&id=44681458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports